import { Component, OnInit } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  uploader: FileUploader;
  allowedMimeType: string[];
  hasBaseDropZoneOver: boolean;
  URL: string;
  filenames: any[];
  queueLimit: number = 100;
  checked: false;

  constructor(
    private router: Router,
    private http: HttpClient,
    public _snackBar: MatSnackBar
  ) {
    this.filenames = [];
    const hospital = localStorage.getItem('hospital_id');
    const account_id = localStorage.getItem('account_id');
    this.URL = `${environment.apiUrl}/upload?hospital_id=${hospital}&account_id=${account_id}`;

    this.uploader = new FileUploader({
      url: this.URL,
      headers: [
        {
          name: 'Authorization',
          value: localStorage.getItem('access_token')
        }
      ]
    });
    this.hasBaseDropZoneOver = false;
    this.uploader.options.allowedMimeType = ['application/dicom', 'image/png'];
    this.uploader.onAfterAddingFile = (fileItem) => this.checkLimitFile(fileItem);
    // this.uploader.onAfterAddingFile = (fileItem) => this.checkMimeType(fileItem);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
  }

  ngOnInit() {
    this.CheckViewer();
    this.UploaderValidateChecking();
    localStorage.setItem('showpercent', JSON.stringify(false))
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  CheckViewer() {
    if (localStorage.getItem('role') == "viewer") {
      this.router.navigate(['main/history']);
    }
  }

  UploaderValidateChecking() {
    this.uploader.onCompleteAll = () => {
      // console.log(this.filenames);
      localStorage.removeItem('diagfiles');
      localStorage.setItem('diagfiles', JSON.stringify(this.filenames))
      // console.log(this.router);
      this.router.navigate(['/main/display']);
      // console.log("Redirect to CXR Screening...");
    }
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    const data = JSON.parse(response);
    // console.log(data);
    this.filenames.push(data);
  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    const data = JSON.parse(response);
    if (data['message'] == 'Package Expire please renew packages.') {
      this._snackBar.open('Package Expire please renew packages.', 'Done', {
        duration: 3000,
      });
    }
    console.log(`Error ${status}: `, data);
  }

  check_percent(){
    localStorage.setItem('showpercent', JSON.stringify(this.checked))
  }

  checkLimitFile(item: FileItem) {
    // Check log
    // console.log(item.file.name.split('.').pop());
    console.log(item.file.type);
    if (this.uploader.queue.length <= this.queueLimit) {
      // console.log("[Queue Length/Queue Limit]: ["+this.uploader.queue.length +":"+ this.queueLimit+"]");
    } else {
      // this.modalWarningQueue = true;
      // console.log("Queue is full, please add more files on next batch.");
      alert('Maximum upload queue, please try again in the next batch.')
      item.remove();
    }
    // if(item.file.name.split('.').pop().toLowerCase() == 'png' || item.file.name.split('.').pop().toLowerCase() == 'dcm'){
    if (item.file.type == 'application/dicom' || item.file.type == '' || item.file.type == 'image/png' || item.file.type == 'application/octet-stream' || item.file.type == 'application/x-msdownload') {

    } else {
      // this.modalWarningMimeType = true;
      alert('Only allow Dicom or PNG files.')
      item.remove();
    }
  }

}
